import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class AbstractTool extends AbstractProvidedClass {
    button;
    arrowMove = 20;
    scrollEnabled = false;
    resetPreviousTool = false;

    setButton(button) {
        this.button = button;
    }

    activate() {
        this.button?.addClass('-is-active');
    }

    deactivate() {
        this.deactivateButton();
    }

    deactivateButton() {
        this.button?.removeClass('-is-active');
    }

    getTips() { }

    display(g) { }

    passArgs() { }

    dragMouse(event) { }

    pressMouseOnCanvas() { }

    releaseMouseOnCanvas() { }

    clickMouseOnCanvas() { }

    doubleClickedOnCanvas() { }

    startTouch(event) { }

    endTouch(event) { }

    moveMouse() { }

    pressKey(code) { }

    pressKeyWithControl(code) { }

    pressKeyWithShift(code) { }

    pressKeyWithAlt(code) { }

    pressKeyHotKeysDisabled(code) { }

    makeSticky(inputField) { }
}
